import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/**
 * Personel performansı (`GET /api/reports/personnel-performance`): son 7 ve 30 gün, kişi başına
 * ve filo ortalaması. Tek skor YOK; uyuşmazlık kanıt listesiyle gelir.
 *
 * PARA KURALI (kural 4): tutarlar ve ortalamalar sunucudan string gelir; panel hesap yapmaz.
 */
export type PerfWindowKey = 'd7' | 'd30';

export interface PerfMismatchTrip {
  tripId: string;
  day: string;
  plate: string;
  /** Yüklenen − satılan − depoya dönen dolu. 0 değilse fark vardır. */
  diffFull: number;
  /** Müşteriden alınan boş − depoya dönen boş. */
  diffEmpty: number;
}

export interface PerfWindowStats {
  tripCount: number;
  deliveredCount: number;
  jugs: number;
  jugsByKind: { kind: string; qty: number }[];
  collected: { cash: string; card: string; online: string; credit: string };
  depositCollected: string;
  bySource: { source: string; deliveredCount: number; jugs: number; amount: string }[];
  mismatch: { closedTrips: number; mismatchTripCount: number; trips: PerfMismatchTrip[] };
}

export interface PerfFleetAverage {
  driverCount: number;
  tripCount: number;
  deliveredCount: number;
  jugs: number;
  collected: { cash: string; card: string; online: string; credit: string };
  mismatchTripCount: number;
}

export interface PersonnelPerformanceRow {
  driver: { id: string; fullName: string; isActive: boolean };
  /** Şoför emaneti: üstündeki nakit (defter toplamı). */
  floatBalance: string;
  d7: PerfWindowStats;
  d30: PerfWindowStats;
}

export interface PersonnelPerformance {
  generatedAt: string;
  windows: Record<PerfWindowKey, { fromDay: string; toDay: string }>;
  drivers: PersonnelPerformanceRow[];
  fleetAverage: Record<PerfWindowKey, PerfFleetAverage>;
}

export function usePersonnelPerformance() {
  return useQuery({
    queryKey: ['reports', 'personnel-performance'],
    queryFn: () => api.get<PersonnelPerformance>('/api/reports/personnel-performance'),
  });
}
